// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AdditionalServiceAttributes_SalvarAtributosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/additional_service_attributes/salvar_atributos/{additional_service_id}
 *
 * Bulk replaces the attribute bindings for an additional service. Returns
 * the count of bindings now persisted for that additional service.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AdditionalServiceAttributes_SalvarAtributosResponseDados {
count: number
}

export type AdditionalServiceAttributes_SalvarAtributosResponse = ApiResponse<AdditionalServiceAttributes_SalvarAtributosResponseDados>;

registerResponseContract('AdditionalServiceAttributes_SalvarAtributosResponse', {
  count: { type: 'number',  required: true },
})
